/* eslint-disable import/no-duplicates */
import { Divider } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import { ProductUIAppWindow } from '../product-ui-app-window/product-ui-app-window';
import { ProductUICursorContainer } from '../product-ui-cursor/product-ui-cursor';
import { ProductUIBasicListItem, ProductUISidebarHeaderItem } from '../product-ui-list-item';
import { ProductUIQuickAddButton } from '../product-ui-quick-add-button/product-ui-quick-add-button';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { ProductUISidebar, ProfileMenu, SideBarSection } from '../product-ui-sidebar/product-ui-sidebar';
import { ProductUISkeletonText } from '../product-ui-skeleton-text/product-ui-skeleton-text';
import { ProductUITask } from '../product-ui-task/product-ui-task';
import { ProductUITaskCircle } from '../product-ui-task-circle/product-ui-task-circle';
import { ProductUIView } from '../product-ui-view/product-ui-view';
function UpcomingViewScene() {
  const {
    t,
    i18n
  } = useTranslation('productui');
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const currentMonthAndYear = today.toLocaleDateString(i18n.language, {
    month: 'long',
    year: 'numeric'
  });
  const todayDayAndDate = today.toLocaleDateString(i18n.language, {
    month: 'long',
    day: 'numeric'
  });
  const tomorrowDayAndDate = tomorrow.toLocaleDateString(i18n.language, {
    month: 'long',
    day: 'numeric'
  });
  return <ProductUISceneContainer backgroundVariant="wave-one" data-sentry-element="ProductUISceneContainer" data-sentry-component="UpcomingViewScene" data-sentry-source-file="upcoming-view.tsx">
            <ProductUISceneLayer position="bottomRight" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="upcoming-view.tsx">
                <ProductUIAppWindow showSidebar inlineSize={808} blockSize="calc(100% + 7px)" sidebar={<ProductUISidebar profileMenu={<ProfileMenu dailyProgress={0.7} />} views={<SideBarSection>
                                    <ProductUIQuickAddButton abstracted />
                                    <ProductUIBasicListItem icon="search" skeletonWidth="20" abstracted />
                                    <ProductUIBasicListItem icon="inbox" skeletonWidth="20" abstracted />
                                    <ProductUIBasicListItem icon="dateToday" skeletonWidth="20" abstracted />
                                    <ProductUICursorContainer size="lg">
                                        <ProductUIBasicListItem icon="dateUpcoming" iconColor="theme" skeletonWidth="20" label={t('sequence.upcomingView.upcoming')} active />
                                    </ProductUICursorContainer>
                                </SideBarSection>} workspaces={<>
                                    <SideBarSection>
                                        <ProductUISidebarHeaderItem icon="personal" abstracted={true} skeletonWidth="60" />
                                    </SideBarSection>
                                    <SideBarSection>
                                        <ProductUISidebarHeaderItem icon="team" abstracted={true} skeletonWidth="40" />
                                    </SideBarSection>
                                </>} />} view={<ProductUIAppWindow.UIViews>
                            <ProductUIView variant="upcoming">
                                <ProductUIView.Header title={currentMonthAndYear} breadcrumbs={[]} />
                                <ProductUIView.Section>
                                    <ProductUIView.SectionTitle>
                                        {todayDayAndDate} • {t('sequence.upcomingView.today')}
                                    </ProductUIView.SectionTitle>
                                    <Divider />
                                    <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                        <ProductUISkeletonText width="40" />
                                    </ProductUITask>
                                    <Divider />
                                    <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                        <ProductUISkeletonText width="100" />
                                    </ProductUITask>
                                    <Divider />
                                    <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                        <ProductUISkeletonText width="20" />
                                    </ProductUITask>
                                    <Divider />
                                    <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                        <ProductUISkeletonText width="100" />
                                    </ProductUITask>
                                    <Divider />
                                </ProductUIView.Section>
                                <ProductUIView.Section>
                                    <ProductUIView.SectionTitle>
                                        {tomorrowDayAndDate} • {t('sequence.upcomingView.tomorrow')}
                                    </ProductUIView.SectionTitle>
                                    <Divider />
                                    <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                        <ProductUISkeletonText width="60" />
                                    </ProductUITask>
                                    <Divider />
                                </ProductUIView.Section>
                            </ProductUIView>
                        </ProductUIAppWindow.UIViews>} data-sentry-element="ProductUIAppWindow" data-sentry-source-file="upcoming-view.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}
export { UpcomingViewScene };